import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

export default class PageLoadingWithText extends Component {
  static propTypes = {
    open: PropTypes.bool,
    text: PropTypes.string,
  };

  renderLoadingSpinner() {
    return (
      <div className='pageloading-loader'>
        <svg className='circular contained-loader-with-text' viewBox='25 25 50 50'>
          <circle className='path' cx='50' cy='50' r='20' fill='none' strokeWidth='3' strokeMiterlimit='10' />
        </svg>
      </div>
    );
  }

  render() {
    const { open, text } = this.props;
    return (
      <div className={ classNames('pageloading', { open }) }>
        <div className='pageloading-body with-text'>
          {this.renderLoadingSpinner()}
          <p className={ 'text-center' }>
            { text }
          </p>
        </div>
      </div>
    );
  }
}
